import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_HORARIOS = 'ALL_HORARIOS';
export const ALL_DOCENTES_HORARIOS = 'ALL_DOCENTES_HORARIOS';
export const ACTIVO_HORARIOS = 'ACTIVO_HORARIOS';
export const LOADING_ALL_HORARIOS = 'LOADING_ALL_HORARIOS';
export const PARAMS_HORARIOS = 'PARAMS_HORARIOS';
export const SETTINGS_HORARIOS = 'SETTINGS_HORARIOS';

const initialState = {
  all: [],
  loadingAll: false,
  docentes: [],
  activo: null,
  settings: {
    newHorario: null,
    isEstatus: false,
    isColor: false,
    isCut: false,
    isEditCalendar: false,
    isCalendarioSeparados: false,
    colorForm: null,
    isHorizontal: true,
    isAll: false,
    isAllDocentes: false,
  },
  params: {
    idHorario: null,
    idDocente: null,
    idSeccion: null,
    idMateria: null,
    idNivelAcademico: null,
  },
};

export const horariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_HORARIOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ALL_DOCENTES_HORARIOS:
      return {
        ...state,
        docentes: action.payload,
      };
    case ACTIVO_HORARIOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SETTINGS_HORARIOS:
      return {
        ...state,
        settings: action.payload,
      };
    case LOADING_ALL_HORARIOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_HORARIOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
